import api from "services/api";

// Get project performance report
export const getProjectPerformance = async (data) => {
  return api.post("/v1/api/reports/project-performance", data);
};

// Get resource utilization report
export const getUtilizationReport = async (data) => {
  return api.post("/v1/api/reports/utilization", data);
};
